import { render, staticRenderFns } from "./AppealReviewPage.vue?vue&type=template&id=2f7ab0a9&scoped=true"
import script from "./AppealReviewPage.vue?vue&type=script&lang=js"
export * from "./AppealReviewPage.vue?vue&type=script&lang=js"
import style0 from "./AppealReviewPage.vue?vue&type=style&index=0&id=2f7ab0a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7ab0a9",
  null
  
)

export default component.exports